import cn from 'classnames';
import { useContext, useMemo } from 'react';

import { CustomStylesCtx } from '@webapp/common/components/custom-styles';
import { CssPageBlock, CssQuestionType, CssUiComponent } from '@webapp/common/components/survey-custom';
import { Textfield } from '@webapp/common/components/textfield';
import { isEmail, setHtml } from '@webapp/common/lib/ui';

import type { SurveyQuestion } from '@webapp/survey/src/components/questions/lib';
import { selectInfo } from '@webapp/survey/src/machine/selectors';
import { useStateSelector } from '@webapp/survey/src/machine/use-state-selector';

import css from './email.css';

export const Email: VFC<SurveyQuestion> = ({
    question: { id: questionId, answersActors, invalid },
    questionBlockPosition,
}) => {
    const {
        params: {
            alert: { email },
        },
    } = useStateSelector(selectInfo);
    const { text: textStyle } = useContext(CustomStylesCtx);

    const withLabel = answersActors.some((answersActor) => {
        const {
            value: [label],
        } = answersActor.getSnapshot().context;
        return !!label;
    });

    const gridStyle: CSSProperties = useMemo(
        () => ({
            gridTemplateRow: withLabel ? 'fit-content(30ch) 3fr' : 'auto',
            justifyContent: questionBlockPosition,
        }),
        [withLabel],
    );

    return (
        <div className={cn(CssQuestionType.QUESTION, CssQuestionType.EMAIL, css.list)} style={gridStyle}>
            {answersActors.map((answersActor) => {
                const {
                    id,
                    response,
                    value: [label],
                } = answersActor.getSnapshot().context;
                const { value: responseValue } = response.getSnapshot().context;
                const showError = !isEmail(responseValue as string) && invalid;

                return (
                    <div className={cn(CssPageBlock.ANSWER, css.answer)} key={id}>
                        {withLabel && (
                            <div
                                className={cn(CssUiComponent.LABEL, css.label)}
                                style={textStyle}
                                {...setHtml(label)}
                            />
                        )}
                        <div className={cn(CssUiComponent.INPUT_WRAP, css.field)}>
                            <Textfield
                                transparent
                                className={css.control}
                                // type={TextfieldType.EMAIL}
                                value={(responseValue as string) || ''}
                                onChange={(v: any): void =>
                                    void response.send({ type: 'CHANGE', value: v, questionId })
                                }
                            />
                        </div>
                        {showError && <div className={cn(CssUiComponent.INVALID, css.requiredText)}>{email}</div>}
                    </div>
                );
            })}
        </div>
    );
};
Email.displayName = 'Email';
